export enum InvoiceIssueTypeDomestic {
    INCORRECT_PRICE = 'Incorrect Price',
    INCORRECT_ACCOUNT = 'Incorrect Account',
    OTHER = 'Other'
}
